class TimeConverter {
	static converter(min) {
		let time;
		if (min < 60) {
			time = `${min}${' '} min${min === 1 ? '' : 's'} ago`;
		} else if (min >= 60 && min < 1440) {
			time = `${Math.floor(min / 60)}${' '} hour${Math.floor(min / 60) === 1 ? '' : 's'} ago `;
		} else if (min >= 1440 && min < 10080) {
			time = `${Math.floor(min / 60 / 24)}${' '} day${Math.floor(min / 60 / 24) === 1 ? '' : 's'} ago `;
		} else if (min >= 10080) {
			time = `${Math.floor(min / 7 / 60 / 24)}${' '} week${Math.floor(min / 7 / 60 / 24) === 1 ? '' : 's'} ago `;
		}
		return time;
	}
}

export default TimeConverter;
